import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import VuePapaParse from 'vue-papa-parse'

Vue.config.productionTip = false

sync(store, router)

Vue.use(VuePapaParse)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
